//noScroll
class ModalEvent {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    // s-movie__leftまたはs-movie__rightをクリックしたときの処理
    document.querySelectorAll('.s-movie__left, .s-movie__right').forEach(function(item) {
      item.addEventListener('click', function() {
        var modalContent = this.classList.contains('s-movie__left') ? '.s-movie__modal-content-01' : '.s-movie__modal-content-02';
        openModal(modalContent);
      });
    });

    // s-movie__modal-closeまたはoverlayをクリックしたときの処理
    document.querySelectorAll('.s-movie__modal-close, .overlay').forEach(function(item) {
      item.addEventListener('click', closeModal);
    });

    // モーダルを開く関数
    function openModal(contentSelector) {
      var modal = document.querySelector('.s-movie__modal');
      var overlay = document.querySelector('.overlay');
      var content = document.querySelector(contentSelector);
      var video_content = content.querySelector('iframe').contentWindow;

      [modal, overlay, content].forEach(function(item) {
        item.classList.add('is-modal');
      });

      video_content.postMessage('{"event":"command","func":"playVideo","args":null}', '*');
    }

    // モーダルを閉じる関数
    function closeModal() {
      var modal = document.querySelector('.s-movie__modal');
      var overlay = document.querySelector('.overlay');
      var contents = document.querySelectorAll('.s-movie__modal-content');
      var video_contents = modal.querySelectorAll('iframe');

      [modal, overlay].forEach(function(item) {
        item.classList.remove('is-modal');
      });

      contents.forEach(function(content) {
        content.classList.remove('is-modal');
        var video = content.querySelector('video');
      });

      video_contents.forEach(function(content) {
        var video_content = content.contentWindow;
        video_content.postMessage('{"event":"command","func":"pauseVideo","args":null}', '*');
      });
    }


  }
}
